/* Shared between the client SEO hook (src/v3/useSeo.js, bundled by webpack)
   and the build-time prerender script (scripts/prerender-blog.js, run
   directly under Node) — plain CommonJS, no ES import/export syntax, so both
   `import { truncate } from './seoText'` (webpack's CJS interop) and
   `require('../src/v3/seoText')` resolve the same functions without a build
   step in between. Keep it that way if you touch this file. */

function truncate(str, max) {
  max = max || 155;
  if (!str) return str;
  if (str.length <= max) return str;
  var cut = str.slice(0, max - 1);
  var lastSpace = cut.lastIndexOf(' ');
  if (lastSpace > max * 0.6) cut = cut.slice(0, lastSpace);
  return cut.trim() + '…';
}

/* items: [{ name, url }] ordered from the home page down to the current page */
function breadcrumbJsonLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(function (item, i) {
      return { '@type': 'ListItem', position: i + 1, name: item.name, item: item.url };
    }),
  };
}

module.exports = { truncate: truncate, breadcrumbJsonLd: breadcrumbJsonLd };
